<template>
    <div class="container-center">

        <h3>回标</h3>

        <iframe scr="http://baidu.com"></iframe>

    </div><!-- container-center -->
</template>

<script>
import banner from '@/assets/imgs/banner_invite.png'
import util from '@/util'

export default {
    name: 'msg-list',
    data () {
        return {
            msgList: [],

            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            }

        }
    },
    methods: {


    },
    created(){

    },
    mounted () {

    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';



</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/NewBid.vue